import { render } from "./theme105.vue?vue&type=template&id=2fc528aa&scoped=true"
import script from "./theme105.vue?vue&type=script&lang=js"
export * from "./theme105.vue?vue&type=script&lang=js"

import "./theme105.vue?vue&type=style&index=0&id=2fc528aa&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2fc528aa"

export default script